module.exports = __webpack_public_path__ + "img/social_media_weibo.9b26e56a.png";